import React from 'react'
import PropTypes from 'prop-types'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Grid from '@material-ui/core/Grid'

import { camelCase } from 'lodash'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
// import { withStyles } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles({
  paper: {
    overflowY: 'hidden'
  }
})
const Modal = ({
  onHide,
  open,
  header,
  children,
  footer,
  size,
  fullWidth,
  disableBackdropClick,
  buttonClose,
  translate,
  addHeader,
  overflow
}) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onHide}
      maxWidth={size}
      fullWidth={fullWidth}
      disableBackdropClick={disableBackdropClick}
      classes={
        !overflow
          ? {
              ...classes
            }
          : {}
      }
      aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>
        <Grid container spacing={3}>
          <Grid item xs={11}>
            {translate(camelCase(header)) || header}
          </Grid>
          {buttonClose ? (
            <Grid item xs={1}>
              <IconButton edge='end' color='inherit' onClick={onHide} aria-label='close'>
                <CloseIcon />
              </IconButton>
            </Grid>
          ) : null}
          {addHeader}
        </Grid>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>{footer}</DialogActions>
    </Dialog>
  )
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  header: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  footer: PropTypes.node,
  fullWidth: PropTypes.bool,
  disableBackdropClick: PropTypes.bool
}

Modal.defaultProps = {
  size: 'sm',
  header: 'modal',
  fullWidth: true,
  disableBackdropClick: false,
  // style: {},
  addHeader: null
}

export default withTranslate(Modal)
